// Cooldown countdown formatter — used by useFirebasePhoneAuth and its
// consumers to render the "Try again in M:SS" line during a Firebase
// auth/too-many-requests cooldown (#otp-cooldown-ui).
//
// Returns mm:ss with the seconds zero-padded. Floors to whole seconds
// so the visible countdown matches setInterval(1000) ticks exactly.
// Negative inputs clamp to '0:00' — defensive, never expected to
// render but harmless if cooldown briefly underflows between the
// hook's tick and the consumer's render.
//
// Mobile mirror lives at apps/mobile/src/utils/cooldown.ts. Source-
// review keeps them in lockstep; the format is too small to justify
// a shared package.

export function formatCooldown(ms: number): string {
  const totalSeconds = Math.max(0, Math.floor(ms / 1000))
  const m = Math.floor(totalSeconds / 60)
  const s = totalSeconds % 60
  return `${m}:${s.toString().padStart(2, '0')}`
}
